import { defineCustomElements } from '@ionic/pwa-elements/loader';
import ReactDOM from 'react-dom';
import App from './App';
import { MessageContextProvider } from './contexts/MessageContext';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
	<MessageContextProvider>
		<App />
	</MessageContextProvider>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

//Disable PWA
//serviceWorker.unregister();

//Enable PWA
serviceWorker.register();

defineCustomElements(window);